import GalleryGridContainer from "../../Componant/Gallery/GalleryGrid";

const GalleryGrid = () => {
  return (
    <div className="page-body">
      <GalleryGridContainer />
    </div>
  );
};

export default GalleryGrid;
